module.exports = __webpack_public_path__ + "img/text-with-icon.3b0825bd.webp";